export var IllustratedMessageVariant;
(function (IllustratedMessageVariant) {
    IllustratedMessageVariant["Vertical"] = "vertical";
    IllustratedMessageVariant["Horizontal"] = "horizontal";
})(IllustratedMessageVariant || (IllustratedMessageVariant = {}));
